<div class="survey-info-step-content">
  <div class="survey-info-step-title">{{ getLangValue(stepData?.title) }}</div>
  <div class="survey-info-step-description" [innerHTML]="getLangValue(stepData?.description)"></div>
  <div class="survey-options-row">
    <div *ngFor="let option of pagedOptions" class="survey-option" [class.selected]="selectedOptionIds.includes(option._id)">
      <button type="button"
              (click)="onToggleOption(option)"
              [class.selected]="selectedOptionIds.includes(option._id)">
        {{ getLangValue(option.text) }}
        <ng-container *ngIf="getLangValue(option.description)?.trim() as desc">
          <span *ngIf="desc"> ({{ desc }})</span>
        </ng-container>
      </button>
    </div>
  </div>
  <button *ngIf="!allOptionsShown" type="button" (click)="onSeeMore()" class="c4g-raised-button show-more-btn">{{ translate.instant('buttons.more') }}</button>
  <div *ngIf="allOptionsShown && selectedOptionIds.length === 0" class="select-hint">{{ translate.instant('Please select at least one option') }}</div>
</div>
